import { gql } from '@apollo/client';
const LOAD_TEST_DATA = gql `
  mutation LoadTestData {
    loadTestData
  }
`;
export default LOAD_TEST_DATA;
